module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "WebApp"
  }, [(!!_vm.notificationForAll) ? _c('notification-bar', {
    attrs: {
      "text": _vm.notificationForAll
    },
    on: {
      "notification-click": _vm.onNotificationClicked
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bar-container"
  }, [_c('headerbar', {
    attrs: {
      "user": _vm.user,
      "service": _vm.service
    }
  }), _vm._v(" "), (!!_vm.notificationText) ? _c('notification-bar', {
    attrs: {
      "text": _vm.notificationText
    }
  }) : _vm._e(), _vm._v(" "), _c('sessionapp', {
    attrs: {
      "surveys": _vm.surveys,
      "progressiveReveal": _vm.progressiveReveal,
      "user": _vm.user,
      "service": _vm.service,
      "currentSlide": _vm.currentSlide,
      "presentation": _vm.activePres,
      "slideList": _vm.sortedSlides,
      "syncSlideNum": _vm.syncSlideNum
    },
    on: {
      "currentSlide": function($event) {
        _vm.getCurrentSlide($event)
      }
    }
  }), _vm._v(" "), _c('bottombar', {
    attrs: {
      "currentSlide": _vm.currentSlide,
      "chatContacts": _vm.chatContacts,
      "chatList": _vm.chatList,
      "slideList": _vm.sortedSlides,
      "presentation": _vm.activePres,
      "presentationList": _vm.presentationList,
      "peopleList": _vm.peopleList,
      "questionList": _vm.questionList,
      "peopleMap": _vm.peopleMap,
      "user": _vm.user,
      "isLoading": _vm.isLoading,
      "isAllowedToListSessions": _vm.isAllowedToListSessions
    },
    on: {
      "getPresentations": _vm.getPresentations
    }
  })], 1), _vm._v(" "), _c('leadgen', {
    attrs: {
      "service": _vm.service,
      "activePres": _vm.activePres,
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51a46ed6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebApp.vue
// module id = 474
// module chunks = 0